export interface WidgetContentItemsState {
	widgetContentItems: {
		contentItems: ContentItem[]
	}
}

export interface ContentItem {
	id: number;
	title: string;
	translucent: boolean;
	availableForUser: boolean;
	contentItemId: string;
	type: string;
	level: number;
	currentStatusColor: string;
}

const state: WidgetContentItemsState = {
	widgetContentItems: {
		contentItems: []
	}
}

export default state
